import { createElement as rc, useState, useCallback } from 'react';
import { Modal, Text, TextInput, Button, Card, h1 } from 'lib_ui-primitives';
import PropTypes from 'prop-types';
import { auth0, globalConfig, session, uiRuntimeConfig } from 'lib_ui-services';

ConfigEntry.propTypes = {
    onConfigChange: PropTypes.func
};
export default function ConfigEntry(props) {
    const { configVisible, closeConfig } = props;
    const [hostname, setHostname] = useState(uiRuntimeConfig.getHostname());
    const [statusVisible, setStatusVisible] = useState(false);

    const update = useCallback(async() => {
        setStatusVisible(true);
        await globalConfig().overrideHostname(hostname, async () => {
            // Logout clears stored credentials and the destination Auth0 browser session
            // before native telemetry can replace the root wrapper. A different source
            // Auth0 domain's browser session and Google/Microsoft sessions are left intact.
            await auth0.init();
            await session.logout(true, false);
        });
        setStatusVisible(false);
        closeConfig();
    }, [closeConfig, hostname]);

    // prettier-ignore
    return rc(Modal, { visible: configVisible },
        rc(Card, null,
            rc(Card.Header, null, rc(h1, null, 'Configuration')),
            !statusVisible && rc(Card.Body, null,
                rc(Text, null, 'Host name'),
                rc(TextInput, {
                    placeholder: '(e.g. dev.sstid.com, localhost or 192.168.xxx.xxx)',
                    value: hostname,
                    onChange: setHostname,
                    sequence: 100
                })
            ),
            statusVisible && rc(Card.Body, null,
                rc(Text, props, 'Changing hostname...')),
            !statusVisible && rc(Card.Footer, null,
                rc(Button, { onClick: update, value: 'OK', color: 'success' }),
                rc(Button, { onClick: closeConfig, value: 'Cancel' })
            )
        )
    );
}
